import { createSSRApp } from "vue";
import * as Pinia from "pinia";
import App from "./App.vue";
import CcImage from "@/components/CcImage/index.vue";
import { setupMonitor } from "@/utils/monitor";

export function createApp() {
  const app = createSSRApp(App);
  
  // 初始化异常监控
  setupMonitor(app);

  app.use(Pinia.createPinia());
  
  // 全局注册 CcImage 组件
  app.component('CcImage', CcImage);
  
  return {
    app,
    Pinia, // 导出 Pinia 供 uni-app 使用
  };
}
